import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/prefer-stateless-function */
import React, { Fragment } from 'react';
import { Redirect } from 'react-router';
import classNames from 'classnames';
import ErrorFeature from '../components/error-feature';
import Spinner from '../components/spinner';
import { getDisplayName } from '../helpers/get-display-name';
import canonicalLink from '../helpers/canonical-link';
import { useGetHrefContext } from '../context';
import DataLayer from '../components/data-layer';
import ErrorPage from './error';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const INTERNAL_SERVER_ERROR = 500;

const pagesHoc = (WrappedComponent, getMetaData, canonicalizeUrl = canonicalLink.canonical) => {
  const NewComponent = props => {
    var _getMetaData;

    const getUrl = useGetHrefContext();
    const {
      centre,
      error,
      loading,
      redirect,
      brand
    } = props;

    if (error) {
      return centre ? /*#__PURE__*/_jsx(ErrorFeature, {
        status: error.code || INTERNAL_SERVER_ERROR,
        error: error
      }) : /*#__PURE__*/_jsx(ErrorPage, {
        status: error.code,
        error: error
      });
    }

    if (loading) {
      // Loading page
      return /*#__PURE__*/_jsx(Spinner, {
        className: classNames({
          brand
        })
      });
    }

    if (redirect) {
      return /*#__PURE__*/_jsx(Redirect, {
        to: redirect
      });
    }

    const canonical = canonicalizeUrl(getUrl(), props);
    const meta = (_getMetaData = getMetaData === null || getMetaData === void 0 ? void 0 : getMetaData(_objectSpread(_objectSpread({}, props), {}, {
      canonical
    }))) !== null && _getMetaData !== void 0 ? _getMetaData : {};
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(DataLayer, _objectSpread({}, meta.datalayer)), /*#__PURE__*/_jsx(WrappedComponent, _objectSpread({}, props))]
    });
  };

  NewComponent.displayName = "Page(".concat(getDisplayName(WrappedComponent), ")");
  return NewComponent;
};

export default pagesHoc;